module.exports = __webpack_public_path__ + "media/images/main/k6-1c066142fe7de178148773021083542d.jpg";